module.exports = __webpack_public_path__ + "components/rewards/sixt/static/icon-387a84c5fa0418f9b82eb00da127a745.png";